module.exports = __webpack_public_path__ + "static/img/topo_blog.c1b6776.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topo_blog.jpg
// module id = kT3n
// module chunks = 0